const algoliaAPI = (prod) => {
    const env = prod ? "production" : "development";

    const indexNames = {
        development: {
            es: {
                recipesIndex: "royalcontigo_com_es_recipe_dev",
                similarRecipesIndex: "royalcontigo_com_es_similarrecipes_dev",
            },
            pt: {
                recipesIndex: "royalcontigo_com_pt_recipe_dev",
                similarRecipesIndex: "royalcontigo_com_pt_similarrecipes_dev",
            }
        },
        production: {
            es: {
                recipesIndex: "royalcontigo_com_es_recipe",
                similarRecipesIndex: "royalcontigo_com_es_similarrecipes",
            },
            pt: {
                recipesIndex: "royalcontigo_com_pt_recipe",
                similarRecipesIndex: "royalcontigo_com_pt_similarrecipes",
            }
        }
    }

    const sharedConfig = [
        {
            pageLanguage: "es",
            searchKey: "4a0efca386695abd97123d98d6703d1b",
        },
        {
            pageLanguage: "pt",
            searchKey: "d8c65301be394a4d1fe7693e6acdb753",
        }
    ]

    return sharedConfig.map(config => ({
        ...config,
        recipesIndex: indexNames[env]?.[config.pageLanguage]?.recipesIndex || "",
        similarRecipesIndex: indexNames[env]?.[config.pageLanguage]?.similarRecipesIndex || "",
    }))
}



const subscriptionAPI = (env) => {
    const appSiteKeys = {
        development: {
            es: "6LetZdoqAAAAAH224FgtU_bGD2GlB4w2yXe4pFLj",
            pt: "6LeuZdoqAAAAAHqJX8vSzAB-9WMf9aYwEaxmAj9A",
        },
        staging: {
            es: "6LerINwqAAAAAJM4O3g-vyqBdxpI6WDc0g4OksG3",
            pt: "6LcdDNwqAAAAAGINhfvTDW62qTYJ5qAsqtGPOEza",
        },
        production: {
            es: "6Ld4i9wqAAAAAKJMjjj03LyDrSoLpBqVEfMKcJ0T",
            pt: "6LffttUqAAAAAFfWKD3IL9OfiObBRx_I6CcEkv6s",
        }
    }
    const sharedConfig = [
        {
            pageLanguage: "es",
            "lang": "es-es",
            "consents": [{
                "name": "_dataProcessing",
                "status": 1,
                "text": "I agree to allow Mondelez to store and process my personal data.",
                "subject": "_dataProcessing",
                "lang": "es-es"
            }],
            "legal": [],
            "persona": {
                "country": "ES"
            },
            "external": {
                "cdilCrm": {
                    "cdilSiteId": "es.royalcontigo.com::es::es::subscription",
                    "domain": "www.royalcontigo.com/es",
                    "campaign": "ROES240201 Royal ES Newsletter Registration",
                    "transaction": "ROES240201 Royal ES Newsletter Registration (IN)",
                }
            }
        },
        {
            pageLanguage: "pt",
            "lang": "pt-pt",
            "consents": [{
                "name": "_dataProcessing",
                "status": 1,
                "text": "I agree to allow Mondelez to store and process my personal data.",
                "subject": "_dataProcessing",
                "lang": "pt-pt"
            }],
            "legal": [],
            "persona": {
                "country": "PT"
            },
            "external": {
                "cdilCrm": {
                    "cdilSiteId": "pt.royalcontigo.com::pt::pt::subscription",
                    "domain": "www.royalcontigo.com/pt",
                    "campaign": "ROPT240101 Royal PT Newsletter Registration Form",
                    "transaction": "ROPT240101 Royal PT Newsletter Registration (IN)",
                }
            }
        }
    ]
    return sharedConfig.map(config => ({
        ...config,
        appSiteKey: appSiteKeys[env]?.[config.pageLanguage] || "",
    }))
}
module.exports = { algoliaAPI, subscriptionAPI }
